// extracted by mini-css-extract-plugin
export default {"overlay":"modal_overlay__oH89o","content":"modal_content__BeHlQ","header":"modal_header__H3dum","body":"modal_body__TbK+F"};